import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';
//let base_url = "https://qa2api.trugreen.com";

const branchAppointmentDataClient = async (postalcode) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.branchAppointmentData()}?postalcode=${postalcode}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    if (!res.ok) {
        return { error: true, message: 'Branch Appointment details request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default branchAppointmentDataClient;
